import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormUtilsService {
  markAsDirty(form: UntypedFormGroup, enable = true) {
    if (enable) {
      this.enableForm(form);
    }

    form.markAsDirty();
    Object.values(form.controls).forEach(control => {
      if (control['controls']) {
        this.markAsDirty(control as UntypedFormGroup);
      }
      control.markAsDirty()
    });
  }

  disableForm(form: UntypedFormGroup) {
    Object.values(form.controls).forEach(control => control.disable());
    form.disable();
  }

  enableForm(form: UntypedFormGroup) {
    Object.values(form.controls).forEach(control => control.enable());
    form.enable();
  }

  toggleDisabled(form: UntypedFormGroup, disabled: boolean) {
    if (disabled) {
      this.disableForm(form);
    } else {
      this.enableForm(form);
    }
  }
}
